import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import SelectMenuWithSearch from "../../controls/SelectMenuWithSearch";

export default function DeleteCategoryForm(props) {
  const { categoryId, categoryOptions, setOpen, actionCall } = props;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [error, setError] = useState(null);

  const handleCategoryChange = (e) => {
    // SelectMenuWithSearch returns the selected option object {value, label} or null
    const selectedOption = e.target.value;
    setSelectedCategory(selectedOption);
    setError(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCategory || !selectedCategory.value) {
      setError("Please select a replacement category");
      return;
    }
    actionCall(categoryId, selectedCategory.value);
  };

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              Delete Category
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <div>
            <p className="text-sm text-gray-600 mb-4">
              Please select a replacement category for products currently using this category.
            </p>
            <div className="mt-3">
              <SelectMenuWithSearch
                title="Replacement Category"
                name="replacementCategory"
                options={categoryOptions}
                handleInputChange={handleCategoryChange}
                placeholder="Select a category..."
                parentClass="w-full"
                menuPortalTarget={document.body}
              />
              {error && (
                <p className="mt-2 text-sm font-medium text-red-500">{error}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          onClick={handleSubmit}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

